<template>
  <div class="mypage-point-history-page" v-if="isIncludeNextRelease">
    <sub-header-section
      :pageTitle="$tc('MypagePage.MypagePointHistoryPage.pageTitle')"
      backLink="/mypage/point-expiration-date"
    />

    <div class="mypage-point-history-page__body">
      <mypage-point-history-pane />
    </div>

    <global-navigation-pane current="mypage" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import SubHeaderSection from '@/components/common/Header/SubHeaderSection.vue'
import GlobalNavigationPane from '@/components/common/GlobalNavigation/GlobalNavigationPane.vue'
import MypagePointHistoryPane from '@/components/MypagePointHistoryPage/MypagePointHistoryPane.vue'

export default defineComponent({
  name: 'MypagePointHistoryPage',
  components: { MypagePointHistoryPane, GlobalNavigationPane, SubHeaderSection },
  setup() {
    // TODO: ポイント獲得履歴表示対応時に消す
    const isIncludeNextRelease = process.env.VUE_APP_INCLUDE_NEXT_RELEASE === 'true'
    return {
      isIncludeNextRelease,
    }
  },
})
</script>

<style scoped lang="scss">
.mypage-point-history-page {
  height: calc(var(--screen-height) - 48px);

  &__body {
    height: calc(100% - 44px - 48px);
    overflow-y: auto;
  }
}
</style>
